<template>
  <section id="services" class="py-32 bg-white relative overflow-hidden">
    <div class="absolute top-1/4 left-0 w-96 h-96 bg-amber-100 rounded-full blur-3xl"></div>
    <div class="absolute bottom-1/4 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl"></div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div class="text-center mb-20">
        <div class="inline-flex items-center px-5 py-2.5 bg-amber-100 rounded-full mb-8">
          <Package :size="20" class="mr-2 text-amber-600" />
          <span class="text-sm font-semibold text-amber-700">产品中心</span>
        </div>

        <h2 class="text-4xl sm:text-5xl font-bold font-display text-dark mb-6">
          精选
          <span class="text-amber-600">食用油脂</span>
          产品
        </h2>

        <p class="text-lg text-gray-600 max-w-3xl mx-auto">
          采用先进工艺精制而成，确保产品品质稳定、安全可靠，满足各类食品加工需求。
        </p>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="(product, index) in products" :key="product.name"
             class="bg-white rounded-3xl overflow-hidden card-hover cursor-pointer group relative"
             :style="{ animationDelay: `${index * 100}ms` }">
          <div class="aspect-[4/3] overflow-hidden">
            <img :src="product.image" :alt="product.name"
                 class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-3">
              <h3 class="text-xl font-bold font-display text-dark group-hover:text-amber-600 transition-colors">
                {{ product.name }}
              </h3>
              <span v-if="product.hot" class="px-3 py-1 bg-red-100 text-red-600 text-xs font-semibold rounded-full">
                热销
              </span>
            </div>
            <p class="text-gray-600 mb-4 text-sm">{{ product.description }}</p>
            <div class="flex items-center justify-between">
              <div>
                <span class="text-lg font-bold text-amber-600">{{ product.price }}</span>
                <span class="text-sm text-gray-400 ml-2">{{ product.unit }}</span>
              </div>
              <button class="px-4 py-2 bg-amber-500 text-white text-sm font-semibold rounded-full hover:bg-amber-600 transition-colors">
                询价
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-20 relative">
        <div class="absolute inset-0 bg-gradient-to-r from-amber-400/20 via-orange-400/20 to-yellow-400/20 rounded-3xl blur-xl"></div>
        <div class="relative bg-white rounded-3xl p-12 shadow-2xl">
          <div class="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 class="text-3xl font-bold font-display text-dark mb-4">批量采购更优惠</h3>
              <p class="text-lg text-gray-600 mb-8">
                量大从优，欢迎食品加工企业洽谈合作。我们提供定制化服务，满足您的特殊需求。
              </p>
              <div class="flex flex-col sm:flex-row gap-4">
                <button class="px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-full hover:opacity-90 transition-all duration-300 shadow-lg shadow-amber-500/30">
                  获取报价
                </button>
                <button class="px-8 py-4 border-2 border-amber-500 text-amber-600 font-semibold rounded-full hover:bg-amber-50 transition-all duration-300">
                  了解详情
                </button>
              </div>
            </div>
            <div class="relative">
              <img :src="workshopImage"
                   alt="生产车间" class="w-full rounded-2xl shadow-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Package } from 'lucide-vue-next'
import productImage1 from '@/assets/images/product-2.jpg'
import productImage2 from '@/assets/images/product-3.jpg'
import productImage3 from '@/assets/images/product-4.jpg'
import productImage4 from '@/assets/images/product-5.jpg'
import productImage5 from '@/assets/images/product-6.jpg'
import productImage6 from '@/assets/images/product-7.jpg'
import workshopImage from '@/assets/images/product-1.jpg'

const products = [
  {
    name: '精炼牛油',
    description: '精选优质牛脂肪，经多道工序精炼而成，色泽洁白，口感细腻。',
    price: '¥18.5',
    unit: '/kg',
    image: productImage1,
    hot: true
  },
  {
    name: '浓香鸡油',
    description: '采用新鲜鸡脂肪熬制，香味浓郁，是调味佳品。',
    price: '¥22.0',
    unit: '/kg',
    image: productImage2,
    hot: true
  },
  {
    name: '浓香牛油',
    description: '保留天然牛脂香味，适合火锅底料、麻辣烫等烹饪。',
    price: '¥20.0',
    unit: '/kg',
    image: productImage3
  },
  {
    name: '原味鸡油',
    description: '口感纯正，营养丰富，适用于各类食品加工。',
    price: '¥20.5',
    unit: '/kg',
    image: productImage4
  },
  {
    name: '原味牛油',
    description: '天然纯净，无添加，保留原始风味。',
    price: '¥19.0',
    unit: '/kg',
    image: productImage5
  },
  {
    name: '牛油软脂',
    description: '质地柔软，易于融化，适合糕点、烘焙使用。',
    price: '¥17.5',
    unit: '/kg',
    image: productImage6
  }
]
</script>
